import React from "react";
import LegalPage from "@/pages/legal/LegalPage";

const Accessibility = () => (
  <LegalPage
    testid="page-accessibility"
    overline="Legal"
    title="Accessibility Statement"
    lastUpdated="December 2025"
  >
    <h2>Our Commitment</h2>
    <p>
      The Exit Strategy Society is committed to ensuring digital accessibility for people of
      all abilities. We strive to continually improve the user experience for everyone and
      apply relevant accessibility standards.
    </p>

    <h2>Conformance Status</h2>
    <p>
      We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1, level AA.
      These guidelines explain how to make web content more accessible for people with
      disabilities and more user-friendly for everyone.
    </p>

    <h2>Ongoing Improvements</h2>
    <p>
      Accessibility is an ongoing effort. We regularly review our website and make
      enhancements to support keyboard navigation, screen reader compatibility, sufficient
      color contrast, and meaningful alternative text for visual elements.
    </p>

    <h2>Feedback</h2>
    <p>
      We welcome your feedback. If you encounter any accessibility barriers on our website,
      please contact us at exitstrategysociety@gmail.com so we may address the issue
      promptly.
    </p>
  </LegalPage>
);

export default Accessibility;
